import chroma from "chroma-js";
export default class Palette {
  constructor() {
    this.handler = {
      down: this.ondown.bind(this),
      move: this.onmove.bind(this),
      up: this.onup.bind(this),
      click: this.onclick.bind(this),
    };
    this.activeColor = "white";
    this.container = document.getElementById("palette");

    this.support = document.createElement("div");
    this.support.id = "support";
    this.container.appendChild(this.support);

    this.container.addEventListener("mousedown", this.handler.down);
    this.container.addEventListener("touchstart", this.handler.down);
    document.addEventListener("mousemove", this.handler.move, {
      passive: false,
    });
    document.addEventListener("touchmove", this.handler.move, {
      passive: false,
    });
    document.addEventListener("mouseup", this.handler.up);
    document.addEventListener("touchend", this.handler.up);
    this.container.addEventListener("click", this.handler.click);
    this.colorSheme();
  }

  hexToRgb(hex) {
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return { r: r, g: g, b: b };
  }

  get activeRGB() {
    return this.hexToRgb(this.activeColor);
  }

  colorSheme() {
    const scheme = [
      "#980043",
      "#e5c8d8",

      "#7a0178",
      "#f9ecf3",

      "#243293",
      "#cce1eb",

      "#065e35",
      "#BFD9A8",

      "#993504",
      "#f5ddb0",

      "#bc0126",
      "#fffbca",

      "#222222",
      "#FAFAFA",
    ];

    for (let i = 0; i < scheme.length; i += 2) {
      const palette = chroma.scale([scheme[i], scheme[i + 1]]).colors(3);
      const list = document.createElement("ul");
      this.support.appendChild(list);
      palette.forEach((color) => {
        const li = document.createElement("li");
        li.style.backgroundColor = color;
        li.setAttribute("data-color", color);
        list.appendChild(li);
      });
    }
  }

  ondown(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    let event = e;
    // if it's a touch event
    if (e.touches) {
      event = e.touches[0];
    }
    this.isDragging = true;
    this.hasBeenDragged = false;
    this.position = this.container.getBoundingClientRect();
    this.offset = {
      x: event.pageX - this.position.left,
      y: event.pageY - this.position.top,
    };
    return false;
  }
  onmove(e) {
    // e.preventDefault();
    if (this.isDragging) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      let event = e;
      // if it's a touch event
      if (e.touches) {
        event = e.touches[0];
      }
      this.container.style.transform = `translate(${
        event.pageX - this.offset.x
      }px,${event.pageY - this.offset.y}px)`;
      const dist = this.dist(
        event.pageX - this.offset.x,
        event.pageY - this.offset.y,
        this.position.left,
        this.position.top
      );
      //   console.log("DIST", dist);
      if (dist > 3) this.hasBeenDragged = true;
      return false;
    }
  }
  onup(e) {
    // e.preventDefault();
    this.isDragging = false;

    // CLICK FIX MOBILE
    if (!this.hasBeenDragged && e.touches) {
      this.activeColor = e.target.getAttribute("data-color");
      console.log("this.activeColor=", this.activeColor);
      console.log(this.activeColor);
      this.resetSelection();
      e.target.classList.add("active");
    }
  }
  resetSelection() {
    const lis = this.container.getElementsByTagName("li");
    Array.from(lis).forEach((li) => {
      li.classList.remove("active");
    });
  }
  onclick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log("click", this.hasBeenDragged);

    if (!this.hasBeenDragged && !e.touches) {
      this.activeColor = e.target.getAttribute("data-color");
      this.resetSelection();
      e.target.classList.add("active");
    }
  }
  dist(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  }

  setActiveColor() {
    this.resetSelection();
    const firstColor = this.container.querySelector("li");
    firstColor.classList.add("active");
    this.activeColor = firstColor.getAttribute("data-color");
  }
}
